(function () {
  class Shuffle extends PIXI.Container {
    constructor() {
      super();

      this._winnings = 0;
      this._distanceToShuffleOut = 100;
      this._midReel = 2;
      this._direction = 1;
      this._animateOutro = true;
      this._inShuffle = false;
      this._stake = 0;
      this._shuffleMask = undefined;

      this._foundReels = [];

      this._maxShuffles = 7;

      this._currentShuttersData = null;
      this._overlayDisplay = null;

      messageBus.subscribe('spinner:GameConfigEvent', this.onGameConfigEvent.bind(this));
      messageBus.subscribe('spinner:ShuffleStartEvent', this.onShuffleStartEvent.bind(this));
      messageBus.subscribe('spinner:ShuffleDataEvent', this.onShuffleDataEvent.bind(this));
      messageBus.subscribe('spinner:ShuffleDataEventDead', this.onShuffleDataEventDead.bind(this));
      messageBus.subscribe('spinner:ShuffleEndEvent', this.onShuffleEndEvent.bind(this));
      messageBus.subscribe('stake:stakeChanged', this.onStakeChanged.bind(this));
      messageBus.subscribe('common:BalanceEvent', this.onCreditChanged.bind(this));
      Reflex.registerEventHandler('layoutChange', this.onLayoutChange.bind(this));
      Reflex.addToUpdate(this.update.bind(this));

      this._payWinsFunc = this.doPayWinsDead.bind(this);
    }

    update(delta, time) {
      if (this._animateOutro) {
        const rot = (Math.PI * 2 * 0.0005 * time) % (Math.PI * 2);
        this._outroRays.rotation = rot;
      }
    }

    onLayoutChange() {
      if (gameController.inShuffle) {
        this.positionMeters();
        if (layoutController.getCurrentLayout() === 'landscape_mobile') {
          this.repositionSkipButton();
        }
      }

      if (layoutController.getCurrentLayout() === 'landscape_mobile') {
        this.repositionOtherButtons();
      }
    }

    onStakeChanged(stake) {
      this._stake = stake;
      this._stakeMeter.set(stake);
    }

    onCreditChanged(creditTask) {
      this._creditMeter.set(creditTask.data.balance);
    }

    onGameConfigEvent() {
      this._reels = [];
      for (let i = 0; i < gameData.numReels; i++) {
        const backer = resourceManager.get('slotContainer:reelContainer:reelsForShuffling:reelBackerReel' + i);
        backer.visible = false;
        const reel = resourceManager.get(
          'slotContainer:reelContainer:reelsForShuffling:reelBackerReel' + i + ':reel' + i
        );
        const shuffleEffectsLayer1 = [
          resourceManager.get(
            'slotContainer:reelContainer:reelsForShuffling:reelBackerReel' + i + ':reel' + i + ':leftEffectLayer1'
          ),
          resourceManager.get(
            'slotContainer:reelContainer:reelsForShuffling:reelBackerReel' + i + ':reel' + i + ':rightEffectLayer1'
          ),
        ];
        const shuffleEffectsLayer2 = [
          resourceManager.get(
            'slotContainer:reelContainer:reelsForShuffling:reelBackerReel' + i + ':reel' + i + ':leftEffectLayer2'
          ),
          resourceManager.get(
            'slotContainer:reelContainer:reelsForShuffling:reelBackerReel' + i + ':reel' + i + ':rightEffectLayer2'
          ),
        ];

        for (let j = 0; j < shuffleEffectsLayer1.length; j++) {
          shuffleEffectsLayer1[j].blendMode = PIXI.BLEND_MODES.ADD;
          shuffleEffectsLayer2[j].blendMode = PIXI.BLEND_MODES.ADD;
        }

        this._reels.push({
          reel,
          backer,
          shuffleEffectsLayer1,
          shuffleEffectsLayer2,
        });
      }
      this._reelsParent = this._reels[0].backer.parent;

      this._creditMeter = resourceManager.get('shuffleCreditContainer:creditMeter');
      this._stakeMeter = resourceManager.get('shuffleBetContainer:BetMeter');

      this._shuffleMeters = [resourceManager.get('shuffleCreditContainer'), resourceManager.get('shuffleBetContainer')];
      this._shuffleMeters.forEach(function (container) {
        container.visible = false;
      });
      this._baseGameMeters = [resourceManager.get('creditContainer'), resourceManager.get('betContainer')];
      this._baseGamewinningsMeterContainer = resourceManager.get('winningsContainer');

      this._outroContainer = resourceManager.getContainer('shuffleOutroContainer');
      this._outroContainer.visible = false;
      this._outroValue = resourceManager.get('shuffleOutroValue');
      this._outroRays = resourceManager.get('shuffleOutroGlowRays');

      this._overlayDisplay = resourceManager.get('overlayDisplay');

      const backer = resourceManager.get('slotContainer:reelFrameBacker:backer');
      this._shuffleMask = new PIXI.Graphics();
      this._shuffleMask.beginFill(0x000000);
      this._shuffleMask.drawRect(20, 20, 830, 486);
      this._shuffleMask.endFill();
      backer.addChild(this._shuffleMask);

      this.volumeButton = resourceManager.get('uiContainer:bg:volume');
      this.mobileLandscapeVolumeMainPos = resourceManager.get('uiContainer:bg:volumeMobileLandscapeNormal');
      this.mobileLandscapeVolumeFeaturePos = resourceManager.get('uiContainer:bg:volumeMobileLandscapeFeature');
    }

    doPayWinsDead(task) {
      this._winnings += task.totalLineWinnings;
    }

    repositionSkipButton() {
      const button = resourceManager.get('buttonContainerMobile:reflexButtonBar:skipWinsButton_portrait');
      button.position.x += 30;
      button.scale = { x: 0.8, y: 0.8 };
    }

    repositionOtherButtons() {
      if (layoutController.getCurrentLayout() === 'landscape_mobile') {
        if (this.mobileLandscapeVolumeMainPos) {
          if (gameController.inShuffle) {
            const pos = this.mobileLandscapeVolumeFeaturePos.position;
            this.volumeButton.position.set(pos.x, pos.y);
          } else {
            const pos = this.mobileLandscapeVolumeMainPos.position;
            this.volumeButton.position.set(pos.x, pos.y);
          }
        }
      }
    }

    resetSkipButton() {
      const button = resourceManager.get('buttonContainerMobile:reflexButtonBar:skipWinsButton_portrait');
      button.position.x -= 30;
      button.scale = { x: 1, y: 1 };
    }

    onShuffleStartEvent(data) {
      gameController.inShuffle = true;

      this.repositionOtherButtons();

      if (layoutController.getCurrentLayout() === 'landscape_mobile') {
        this.repositionSkipButton();
      }

      this._inShuffle = true;
      resourceManager.getController('inputOverlord').setState('shuffle');

      this.positionMeters();
      this._winnings = 0;
      messageBus.subscribe('spinner:WinningLinesEventDead', this._payWinsFunc);

      gdk.getNextGameOutcome(function () {});

      this._baseGameMeters.forEach(function (container) {
        container.visible = false;
      });
      this._shuffleMeters.forEach(function (container) {
        container.visible = true;
      });

      gameController.multiplierTrail.setTrailPanels(true, false);
    }

    onShuffleEndEvent(task) {
      gameController.inShuffle = false;
      this.repositionOtherButtons();

      task.join();
      const self = this;
      timerManager.addTimeout(2000, function () {
        self.endShuffle(task);
      });
    }

    endShuffle(task) {
      if (layoutController.getCurrentLayout() === 'landscape_mobile') {
        this.resetSkipButton();
      }
      if (!gameController.bigWin.checkBigWin(task.data.shuffleWinnings)) {
        this._outroValue.setText(gdk.formatCurrency(task.data.shuffleWinnings));
        this._outroContainer.visible = true;
        this._outroContainer.alpha = 0;
        this._animateOutro = task.data.shuffleWinnings > this._stake;
        const self = this;

        musicManager.onFeatureEnd();
        timerManager.addTimer(
          500,
          function (progress) {
            self._outroContainer.alpha = progress;
          },
          function () {
            self._outroContainer.alpha = 1;
            timerManager.addDelayedTimer(
              2000,
              500,
              function (progress) {
                self._outroContainer.alpha = 1 - progress;
              },
              function () {
                self._outroContainer.alpha = 1;
                self._outroContainer.visible = false;
                task.leave();
                self.backToBaseGame();
              }
            );
          }
        );
      } else {
        task.leave();
      }
    }

    onShuffleDataEvent(task) {
      task.join();

      this._lastShuffle = task.data.lastShuffle;
      this._multiplier = task.data.multiplier;
      this._currentShuttersData = task.data.shuttersData;
      this._previousShutterPositions = task.data.previousShutterPositions;
      this._shuffleStartReelList = task.data.startReelList;
      this._shuffleEndReelList = task.data.endReelList;
      this._shufflePerm = task.data.perm;
      this._currentShuffleWinAmount = task.data.winAmount || 0;

      // Update gameController.mysteryData so win animations use correct symbol for this shuffle
      if (this._currentShuttersData && this._currentShuttersData.symbol !== undefined) {
        if (gameController.mysteryData) {
          gameController.mysteryData.symbol = this._currentShuttersData.symbol;
        }
      }

      // If there are pending sparkles, trigger them BEFORE next shuffle
      if (gameController.overlayDisplay._sparklesPending) {
        const self = this;
        // Trigger sparkles first, then run shuffle animation
        gameController.overlayDisplay.triggerPendingSparkles(function () {
          self.runShuffleAnimation(task);
        });
      } else {
        // Run shuffle animation immediately
        this.runShuffleAnimation(task);
      }
    }

    /**
     * Run the shuffle animation. Trail and sparkles will animate after wins complete.
     * @param {object} task - The ShuffleDataEvent task to leave when complete
     */
    runShuffleAnimation(task) {
      const self = this;

      timerManager.addTimeout(1500, function () {
        // Check if we have shutter data for close/open animations
        const hasShutterData =
          self._currentShuttersData &&
          self._currentShuttersData.positions &&
          self._currentShuttersData.positions.length > 0;
        const hasPreviousPositions = self._previousShutterPositions && self._previousShutterPositions.length > 0;

        if (hasShutterData && hasPreviousPositions) {
          // Filter out shutter positions where awards (Wild/SuperWild/MegaWild) were placed
          let shutterPositionsToClose = self._previousShutterPositions;
          // if (self._overlayDisplay._sparkleData && self._overlayDisplay._sparkleData.length > 0) {
          //   shutterPositionsToClose = self._previousShutterPositions.filter(function (shutterPos) {
          //     for (let i = 0; i < self._overlayDisplay._sparkleData.length; i++) {
          //       const awardPos = self._overlayDisplay._sparkleData[i];
          //       if (shutterPos.reel === awardPos.reel && shutterPos.row === awardPos.row) {
          //         return false; // Award symbol should stay visible
          //       }
          //     }
          //     return true; // Close this shutter
          //   });
          // }

          self._overlayDisplay.closeShuttersForShuffle(shutterPositionsToClose, function () {
            // Set symbols to mystery (8) at shutter positions so closed shutters show
            const symbolsInfo = resourceManager.getConfiguration().symbols;
            const mysteryId = symbolsInfo['Mystery'].ID;
            for (let i = 0; i < shutterPositionsToClose.length; i++) {
              const pos = shutterPositionsToClose[i];
              // Update main reels
              gameData.reels[pos.reel].setReelSymbol(pos.row, mysteryId);
              gameData.reels[pos.reel].update();
              self._shuffleStartReelList[pos.reel].symbols[pos.row].value = mysteryId;
            }

            // Perform shuffle animation
            self.shuffle(
              self._shuffleStartReelList,
              self._shuffleEndReelList,
              function () {
                // Open shutters at NEW positions (where they end up after shuffle)
                self._overlayDisplay.openShuttersAfterShuffle(
                  self._currentShuttersData.positions,
                  self._currentShuttersData.symbol,
                  function () {
                    self.completeShuffleAnimation(task);
                  }
                );
              },
              self._shufflePerm,
              self._currentShuttersData.positions
            );
          });
        } else {
          // No shutter data, proceed with normal shuffle
          self.shuffle(
            self._shuffleStartReelList,
            self._shuffleEndReelList,
            function () {
              self.completeShuffleAnimation(task);
            },
            self._shufflePerm,
            null
          );
        }
      });
    }

    /**
     * Complete the shuffle animation and handle trail/sparkles.
     * @param {object} task
     */
    completeShuffleAnimation(task) {
      const self = this;

      if (self._currentShuffleWinAmount === 0) {
        gameController.animateTrailAfterWins(function () {
          task.leave();
          if (!self._lastShuffle) {
            gdk.getNextGameOutcome(function () {});
          }
        });
      } else {
        task.leave();
      }
    }

    onShuffleDataEventDead(task) {
      // getNextGameOutcome is called after trail animation in gameController.winlineAnimsDone
    }

    backToBaseGame() {
      messageBus.unsubscribe('spinner:WinningLinesEventDead', this._payWinsFunc);

      this._baseGameMeters.forEach(function (container) {
        container.visible = true;
      });
      this._shuffleMeters.forEach(function (container) {
        container.visible = false;
      });
      gameData.winningsMeter.set(this._winnings);

      //this._baseGamewinningsMeterContainer.position.set(
      //  layoutController.getCurrentPosition('winningsContainer').x,
      //  layoutController.getCurrentPosition('winningsContainer').y
      //);

      this._inShuffle = false;
      this._animateOutro = true;
      if (!gdk.serverParser._inReplayMode) {
        resourceManager.getController('inputOverlord').setState('enabled');
      }
    }

    positionMeters() {}

    moveReel(reel, from, to, progress) {
      const startX = layoutController.getCurrentPosition(this._reels[from].backer.Props.FQN).x;
      const endX = layoutController.getCurrentPosition(this._reels[to].backer.Props.FQN).x;

      const dist = (endX - startX) * progress;
      reel.position.setX(startX + dist);
    }

    moveToMiddle(callback) {
      const self = this;
      timerManager.addTimer(
        500,
        function (progress) {
          self._reels.forEach(function (reel, i) {
            self.moveReel(reel.backer, i, self._midReel, progress);
          });
        },
        function () {
          self._reels.forEach(function (reel, i) {
            self.moveReel(reel.backer, i, self._midReel, 1);
          });

          callback();
        }
      );
    }

    findReel(reelSymbols, reelList) {
      for (let reel = 0; reel < reelList.length; ++reel) {
        let allFound = true;
        for (let row = 0; row < reelList[reel].symbols.length; ++row) {
          const symbolLeft = reelSymbols[row];
          const symbolRight = reelList[reel].symbols[row].value;
          if (symbolRight !== symbolLeft || this._foundReels.includes(reel)) {
            allFound = false;
            break;
          }
        }
        if (allFound && !this._foundReels.includes(reel)) {
          this._foundReels.push(reel);
          return reel;
        }
      }
      return -1;
    }

    shuffle(startingSymbols, resultingSymbols, callback, perm, newShutterPositions) {
      gameController.winSkipped = false;

      gameController.playLogoAnim();
      soundManager.play('shuffle');

      musicManager.fadeShuffleMusicLevel(gameController.multiplierTrail.getCurrentTotalLevel());

      this._callback = callback;
      this._resultingSymbols = resultingSymbols;
      this._startingSymbols = startingSymbols;
      this._newShutterPositions = newShutterPositions;
      this._startToEndReel = [];
      for (let reel = 0; reel < startingSymbols.length; ++reel) {
        let reelSymbols = [];
        for (let row = 0; row < startingSymbols[reel].symbols.length; ++row) {
          const symbolId = startingSymbols[reel].symbols[row].value;
          this._reels[reel].reel.setReelSymbol(row, symbolId);
          this._reels[reel].reel.update();

          reelSymbols.push(symbolId);
        }
        const endReel = perm.indexOf(reel);
        this._startToEndReel.push({ startReel: reel, endReel });
      }
      // Reset found reels
      this._foundReels = [];
      const self = this;
      this._reels.forEach(function (reel, i) {
        reel.backer.visible = true;
        reel.backer.alpha = 0;
        reel.shuffleEffectsLayer1.forEach((effect) => {
          effect.gotoAndPlay(0);
        });
        reel.shuffleEffectsLayer2.forEach((effect) => {
          effect.gotoAndStop(0);
        });
      });
      timerManager.addTimer(500, undefined, function () {
        self._reels.forEach(function (reel) {
          reel.shuffleEffectsLayer2.forEach((effect) => {
            effect.gotoAndPlay(0);
          });
        });
      });
      timerManager.addTimer(
        500,
        function (progress) {
          self._reels.forEach(function (reel) {
            reel.backer.alpha = progress;
          });
        },
        function () {
          // Hide overlay shutters now that reel shutters have faded in
          if (self._overlayDisplay) {
            self._overlayDisplay.hideShuffleShutters();
          }
          gameData.reels.forEach(function (reel) {
            reel.visible = false;
          });
          self._shuffleCount = 0;
          self.moveToMiddle(function () {
            self.shuffleReel();
          });
        }
      );
    }

    shuffleReel() {
      const reelToShuffle = 0;
      const reel = this._reelsParent.getChildAt(reelToShuffle);
      this.shuffleToFront(reel);
    }

    shuffleToFront(reel) {
      this._direction *= -1;
      const self = this;

      const ARC_OUT = 30;
      const ARC_IN = 30;
      const EXTRA_OFFSET = 120;
      const SCALE_PEAK = 0.15;

      const midPos = layoutController.getCurrentPosition(self._reels[self._midReel].backer.Props.FQN);

      const cx = midPos.x;
      const cy = midPos.y;

      const offset = self._distanceToShuffleOut + EXTRA_OFFSET;
      const outX = cx + self._direction * offset;
      reel.mask = this._shuffleMask;

      let swapped = false;

      timerManager.addTimer(
        400,
        function (t) {
          let x, y, scale;

          if (t < 0.5) {
            const p = t * 2;

            x = cx + (outX - cx) * p;
            y = cy - Math.sin(p * Math.PI) * ARC_OUT;

            scale = 1 + Math.sin(p * Math.PI * 0.5) * SCALE_PEAK;
          } else {
            const p = (t - 0.5) * 2;

            if (!swapped) {
              self._reelsParent.setChildIndex(reel, self._reelsParent.children.length - 1);
              swapped = true;
            }

            x = outX + (cx - outX) * p;
            y = cy + Math.sin(p * Math.PI) * ARC_IN;

            scale = 1 + Math.cos(p * Math.PI * 0.5) * SCALE_PEAK;
          }

          reel.position.set(x, y);
          reel.scale.set(scale, scale);
        },
        function () {
          reel.position.set(cx, cy);
          reel.scale.set(1, 1);
          self.waitForNextShuffle();
        }
      );
    }

    waitForNextShuffle() {
      ++this._shuffleCount;
      if (this._shuffleCount < this._maxShuffles) {
        const self = this;
        timerManager.addTimeout(1, function () {
          self.shuffleReel();
        });
      } else {
        this.moveBack();
      }
    }

    moveBack() {
      const self = this;
      timerManager.addTimer(
        500,
        function (progress) {
          self._reels.forEach(function (reel, i) {
            const endReel = self._startToEndReel[i].endReel;
            self.moveReel(reel.backer, self._midReel, endReel, progress);
          });
        },
        function () {
          self._reels.forEach(function (reel, i) {
            const endReel = self._startToEndReel[i].endReel;
            self.moveReel(reel.backer, self._midReel, endReel, 1);
          });
          // Reposition shuffle reel backers to original positions
          for (let reel = 0; reel < self._reels.length; ++reel) {
            self.moveReel(self._reels[reel].backer, 0, reel, 1);
          }
          // show overlay shutters
          if (self._overlayDisplay && self._newShutterPositions) {
            self._overlayDisplay.showClosedShuttersAtPositions(self._newShutterPositions);
          }
          gameData.reels.forEach(function (reel, i) {
            reel.visible = true;
          });
          for (let reel = 0; reel < self._reels.length; ++reel) {
            for (let row = 0; row < gameData.numRows; ++row) {
              const symbolId = self._resultingSymbols[reel].symbols[row].value;
              gameData.reels[reel].setReelSymbol(row, symbolId);
              gameData.reels[reel].update();
              self._reels[reel].reel.setReelSymbol(row, symbolId);
              self._reels[reel].reel.update();
            }
          }
          //Fade back to actual reals after shuffle
          timerManager.addTimer(
            500,
            function (progress) {
              self._reels.forEach(function (reel, i) {
                reel.backer.alpha = 1 - progress;
              });
            },
            function () {
              self._reels.forEach(function (reel) {
                reel.backer.alpha = 1;
                reel.backer.visible = false;
              });
              self._callback();
            }
          );
        }
      );
    }
  }

  let creator = function (json) {
    return new Shuffle(json.reel);
  };

  let initialiser = function (json, shuffle) {};

  let filesRequired = function () {
    return [];
  };

  resourceManager.registerObjectType('shuffle', creator, initialiser, filesRequired);
})();
